module.exports = __webpack_public_path__ + "static/media/illustration-departamento-vazio.cd75caf0.svg";